import React, {
    createContext, useContext, useMemo, useState,
} from 'react';

const QueryContext = createContext();

function QueryProvider({ children }) {
    const [queryClient, setQueryClient] = useState({});

    const queryContextValue = useMemo(() => ({
        queryClient, setQueryClient,
    }), [queryClient, setQueryClient]);

    return <QueryContext.Provider value={queryContextValue}>{children}</QueryContext.Provider>;
}

function withQuery(Component) {
    return function (props) {
        return (
            <QueryProvider>
                <Component {...props} />
            </QueryProvider>
        );
    };
}

function useQueryClient() {
    const context = useContext(QueryContext);

    if (context === undefined) {
        throw new Error('useQueryClient must be used within a QueryProvider');
    }

    return context;
}

export { QueryProvider, useQueryClient, withQuery };
